var _Rect, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 22,
    height: 22,
    fill: "#6E0905",
    rx: 5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFCC59",
    fillRule: "evenodd",
    d: "M7.944 17.48a1.42 1.42 0 0 1-.008-1.93l3.895-4.154-3.895-4.154a1.42 1.42 0 0 1 .008-1.929 1.24 1.24 0 0 1 1.823.008l3.947 4.21c.965 1.03.965 2.7 0 3.73l-3.947 4.21a1.24 1.24 0 0 1-1.823.008",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;